// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import OverlayTrigger from './overlay-trigger';

class TooltipTrigger extends Component {
    getOverlayProps() {
        const {className, displayDirection, tooltipRenderer} = this.props;

        return {
            className: classnames('tooltip-trigger', className),
            displayDirection,
            overlayRenderer: tooltipRenderer,
            triggerType: 'hover',
        };
    }

    render() {
        const {children} = this.props;

        return <OverlayTrigger {...this.getOverlayProps()}>{children}</OverlayTrigger>;
    }
}

TooltipTrigger.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    displayDirection: PropTypes.string,
    tooltipRenderer: PropTypes.func.isRequired,
};

export default TooltipTrigger;
